import {
  CircleAlert,
  CircleCheck,
  CircleDashed,
  Clock,
  Hourglass,
  LoaderCircle,
  Lock,
  type LucideIcon,
  PowerOff,
  ShieldAlert,
  ShieldX,
} from 'lucide-react';

import { type TomBadge } from '@/ui/primitives/estilos';
import { type SituacaoCaptura, type StatusExecucaoCaptura } from '@fiscoai/contracts';

export interface Visual {
  rotulo: string;
  tom: TomBadge;
  Icone: LucideIcon;
  /** O ícone gira (busca em andamento). */
  girando?: boolean;
}

/** Situação da captura: ícone + texto + tom (nunca só a cor). */
export const VISUAL_SITUACAO: Record<SituacaoCaptura, Visual> = {
  DESLIGADA: { rotulo: 'Desligada', tom: 'neutro', Icone: PowerOff },
  AGUARDANDO: { rotulo: 'Aguardando', tom: 'neutro', Icone: Clock },
  EXECUTANDO: { rotulo: 'Buscando', tom: 'marca', Icone: LoaderCircle, girando: true },
  ESPERA_SEFAZ: { rotulo: 'Espera da SEFAZ', tom: 'info', Icone: Hourglass },
  BLOQUEADA: { rotulo: 'Bloqueada', tom: 'alerta', Icone: Lock },
  SEM_CERTIFICADO: { rotulo: 'Sem certificado', tom: 'alerta', Icone: ShieldAlert },
  CERTIFICADO_VENCIDO: { rotulo: 'Certificado vencido', tom: 'alerta', Icone: ShieldX },
  ERRO: { rotulo: 'Erro', tom: 'perigo', Icone: CircleAlert },
};

/** Resultado de uma execução no histórico. */
export const VISUAL_EXECUCAO: Record<StatusExecucaoCaptura, Visual> = {
  EXECUTANDO: { rotulo: 'Buscando', tom: 'marca', Icone: LoaderCircle, girando: true },
  CONCLUIDA: { rotulo: 'Concluída', tom: 'sucesso', Icone: CircleCheck },
  SEM_NOVIDADE: { rotulo: 'Sem novidade', tom: 'neutro', Icone: CircleDashed },
  BLOQUEADA: { rotulo: 'Bloqueada', tom: 'alerta', Icone: Lock },
  SEM_CERTIFICADO: { rotulo: 'Sem certificado', tom: 'alerta', Icone: ShieldAlert },
  CERTIFICADO_VENCIDO: { rotulo: 'Certificado vencido', tom: 'alerta', Icone: ShieldX },
  ERRO: { rotulo: 'Erro', tom: 'perigo', Icone: CircleAlert },
};
